import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Box, Flex, Img, Text} from '@chakra-ui/react'
import useDamImage from '../../../../custom-hooks/use-dam-image'

export const SortingTile = ({styles, tile, variant}) => {
    const damImage = useDamImage(tile.image)

    return (
        <Flex data-testid="sorting-tile" flexDirection={'column'} {...styles.tile}>
            {(damImage.url || tile.image?.alt) && (
                <AspectRatio ratio={damImage.ratio}>
                    <Img src={damImage.url} alt={tile.image?.alt || ''} />
                </AspectRatio>
            )}
            {tile.title && (
                <Text
                    as="h3"
                    textStyle="head-small"
                    fontWeight={'medium'}
                    color={variant === 'black' ? 'text.inverse' : 'text.default'}
                    {...styles.tiletitle}
                >
                    {tile.title}
                </Text>
            )}
            {tile.body_copy && (
                <Box
                    textStyle="body-medium"
                    fontWeight={'normal'}
                    color={variant === 'black' ? 'text.inverse' : 'text.default'}
                    {...styles.tilebodycopy}
                    dangerouslySetInnerHTML={{__html: tile.body_copy}}
                />
            )}
        </Flex>
    )
}

SortingTile.propTypes = {
    styles: PropTypes.shape(),
    tile: PropTypes.shape({
        title: PropTypes.string,
        body_copy: PropTypes.string,
        image: PropTypes.shape(),
        features: PropTypes.arrayOf(PropTypes.shape({feature: PropTypes.string})),
        cta: PropTypes.shape({title: PropTypes.string, href: PropTypes.string}),
    }),
    variant: PropTypes.string,
}
